(() => {
  const tag = 'gdp-search-price-order';
  if (customElements.get(tag)) return;

  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      // A facet response replaces the section's children. Each new marker runs once.
      queueMicrotask(() => this.orderCards());
    }

    orderCards() {
      if (!this.isConnected) return;
      const order = this.getAttribute('order');
      if (order !== 'price-ascending' && order !== 'price-descending') return;
      if (new URL(location.href).searchParams.get('sort_by') !== order) return;
      if (this.getAttribute('pages') !== '1') {
        this.dataset.status = 'skipped-pagination';
        return;
      }
      const list = document.getElementById(this.getAttribute('for'));
      const section = this.closest('.shopify-section');
      if (!section || !list || list.closest('.shopify-section') !== section) return;
      const cards = Array.from(list.children).filter(node => node.tagName === 'PRODUCT-CARD');
      const expected = Number(this.getAttribute('expected'));
      if (!Number.isSafeInteger(expected) || expected < 1 || cards.length !== expected) return;

      let invalid = false;
      const entries = cards.map((card, index) => {
        const price = card.querySelector('.gdp-price-wrapper sale-price');
        // A card with no displayed price keeps its original slot.
        if (!price) return { card, index, cents: null };
        const raw = price.getAttribute('data-gdp-sort-cents');
        const cents = raw !== null && /^\d+$/.test(raw) ? Number(raw) : NaN;
        if (!Number.isSafeInteger(cents)) invalid = true;
        return { card, index, cents };
      });
      if (invalid) return;
      const direction = order === 'price-ascending' ? 1 : -1;
      const priced = entries.filter(entry => entry.cents !== null)
        .sort((a, b) => direction * (a.cents - b.cents) || a.index - b.index);
      let position = 0;
      const ordered = entries.map(entry => entry.cents === null ? entry.card : priced[position++].card);
      if (ordered.some((card, index) => card !== cards[index])) list.append(...ordered);
      this.dataset.status = 'applied';
    }
  });
})();
